const SW_PATH = '/sw.js';

let registrationPromise = null;

export const registerServiceWorker = () => {
    if (!('serviceWorker' in navigator)) return Promise.resolve(null);

    if (!registrationPromise) {
        registrationPromise = navigator.serviceWorker.register(SW_PATH).catch(error => {
            registrationPromise = null;
            console.error('Service worker registration failed:', error);
            return null;
        });
    }

    return registrationPromise;
};

export const getServiceWorkerRegistration = () => {
    if (!('serviceWorker' in navigator)) return Promise.resolve(null);
    return navigator.serviceWorker.getRegistration();
};

// Install prompt capture — initialized explicitly via initInstallPrompt()
let capturedPrompt = null;
const listeners = new Set();
let initialized = false;

export const initInstallPrompt = () => {
    if (initialized) return;
    initialized = true;

    window.addEventListener('beforeinstallprompt', e => {
        e.preventDefault();
        capturedPrompt = e;
        listeners.forEach(fn => fn(e));
    });

    window.addEventListener('appinstalled', () => {
        capturedPrompt = null;
        listeners.forEach(fn => fn(null));
    });
};

export const getInstallPrompt = () => capturedPrompt;

export const clearInstallPrompt = () => {
    capturedPrompt = null;
};

export const onInstallPromptChange = handler => {
    listeners.add(handler);
    return () => listeners.delete(handler);
};
